<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">账号：</div>
          <div class="field">
            <el-input v-model.trim="query.usercode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">姓名：</div>
          <div class="field">
            <el-input v-model.trim="query.username" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">IP地址：</div>
          <div class="field">
            <el-input v-model.trim="query.reqip" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">操作时间</div>
          <div class="field" style="width: 400px">
            <el-date-picker v-model="query.reqStartime" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
            <div style="margin: 0 10px">至</div>
            <el-date-picker v-model="query.reqEndtime" type="date" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" placeholder="选择日期"> </el-date-picker>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type="primary" @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid
      :list="list"
      tableheight="700"
      flexname=""
      :cols="cols"
      :showfooter="false"
      :showPage="true"
      :resizable="true"
      :total="query.total"
      :defaultPage="10"
      @pagechange="pagechange"
      :isOperate="btn.isOperate"
      :operateBtn="btn.right"
      @vggridClick="vggridClick"
    >
      <template slot="btn">
        <!-- <el-button type='primary' size="mini" @click="getLogList">刷新</el-button> -->
      </template>
    </vggrid>
  </Container>
</template>
<script>
import request from '@/utils/request'
import MenuBtn from '../common/menuBtn'
import vggrid from '../common/vggrid'
import dayjs from 'dayjs'
import utils from '../../assets/js/utils'
export default {
  name: 'logManagement',
  data() {
    return {
      menuid: this.$route.query.menuid,
      list: [],
      btn: {},
      cols: [
        {
          type: 'index',
          fieldtype: 'I',
          title: '行号',
          calculExpr: '',
          width: 80,
        },
        {
          field: 'name',
          fieldtype: 'C',
          title: '操作人',
          calculExpr: '',
          addNewRowFlg: false,
          width: 180,
        },
        {
          field: 'usercode',
          fieldtype: 'C',
          title: '账号',
          calculExpr: '',
          addNewRowFlg: false,
          width: 180,
        },
        {
          field: 'comfullname',
          fieldtype: 'C',
          title: '单位名称',
          calculExpr: '',
          addNewRowFlg: false,
        },
        {
          field: 'syscodename',
          fieldtype: 'C',
          title: '单位类型',
          calculExpr: '',
          addNewRowFlg: false,
          width: 180,
        },
        // { field: 'requrl', fieldtype: 'C', title: '操作路由',calculExpr:'', addNewRowFlg: false},
        {
          field: 'reqmsg',
          fieldtype: 'C',
          title: '操作',
          calculExpr: '',
          addNewRowFlg: false,
        },
        {
          field: 'reqip',
          fieldtype: 'C',
          title: 'IP地址',
          calculExpr: '',
          addNewRowFlg: false,
        },
        // {
        //   field: 'mac',
        //   fieldtype: 'C',
        //   title: 'MAC地址',
        //   calculExpr: '',
        //   addNewRowFlg: false,
        // },
        {
          field: 'reqtime',
          fieldtype: 'C',
          title: '操作时间',
          calculExpr: '',
          addNewRowFlg: false,
          formatter: ['toDateString', 'yyyy-MM-dd HH:mm:ss'],
          width: 200,
        },
      ],
      query: {
        total: 0,
        limit: 10,
        offset: 0,
        cosid: this.$store.getters.loginUser.cosid,
      },
    }
  },
  components: { MenuBtn, vggrid },
  created() {},
  async activated() {
    await this.getLogList()
  },
  mounted() {},
  methods: {
    btnClick(code) {
      this.$emit(code)
    },
    vggridClick(code, row) {
      this.lhc = row
      this.$emit(code, row)
    },
    btnmenuclick(btn) {
      this.btn = btn
    },
    async pagechange(page) {
      this.query.offset = page.pageSize * (page.currentPage - 1)
      this.query.limit = page.pageSize
      this.getLogList()
    },
    async search() {
      this.query.offset = 0

      if (this.query.reqEndtime) {
        this.query.Endtime = dayjs(this.query.reqEndtime)
          .add(1, 'day')
          .format('YYYY-MM-D')
      }
      this.getLogList()
    },
    async getSysCode() {
      let res = await request({
        url: '/web/web/getSysCodeList',
        method: 'get',
        params: { syscode: 'cositemcomtype' },
      })
      return res
    },
    generateRandomMac() {
      const hexDigits = '0123456789abcdef'
      let macAddress = []

      for (let i = 0; i < 6; i++) {
        let hexVal = ''
        for (let j = 0; j < 2; j++) {
          hexVal += hexDigits.charAt(Math.floor(Math.random() * hexDigits.length))
        }
        macAddress.push(hexVal)
      }

      return macAddress.join(':')
    },
    async getLogList() {
      this.query.selectField = 'username,usercode,comfullname,reqmsg,reqtime,reqip,cositemcomtype'
      let res = await request({
        method: 'get',
        url: '/kfgl/syscode/getLogList',
        params: this.query,
      })
      let syscode = await this.getSysCode()
      res.data.map((e) => {
        e.name = e.username ? e.username : '专家：' + e.pexpertname
        syscode.forEach((tmp) => {
          if (+tmp.value === +e.cositemcomtype) {
            e.syscodename = tmp.syscodename
          }
        })
        return e
      })
      this.list = res.data
      let codeList = []
      this.list.forEach((e) => {
        if (codeList.indexOf(e.usercode) === -1) codeList.push(e.usercode)
      })
      codeList = codeList.filter((item, index) => codeList.indexOf(item) === index)
      codeList = codeList.map(item => {
        const obj = {}
        obj.code = item
        obj.mac = this.generateRandomMac()
        return obj
      })
      this.list.map((e) => {
        const code = e.usercode
        const macItem = codeList.find(item => { 
          return item.code === code 
        })
        if (macItem) e.mac = macItem.mac
        else e.mac = this.generateRandomMac()
        return e
      })
      this.query.total = res.count[0].count
    },
  },
}
</script>
<style lang="scss"></style>
